import { render, staticRenderFns } from "./TabelaProcessos.vue?vue&type=template&id=b07b8f7c&scoped=true&"
import script from "./TabelaProcessos.vue?vue&type=script&lang=js&"
export * from "./TabelaProcessos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaProcessos.vue?vue&type=style&index=0&id=b07b8f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07b8f7c",
  null
  
)

export default component.exports